export default __webpack_public_path__ + "static/media/329.8eff0bcc.gif";